import * as React from 'react';
import { BoardComponent } from './components/BoardComponent';
import { LoadingComponent } from './components/LoadingComponent';

interface IAppState {
  loaded: boolean;
}

class App extends React.Component<any, IAppState> {

  componentWillMount () {
    this.setState({ loaded: false });
  }

  onLoad = () => {
    this.setState({ loaded: true });
  }

  public render() {
    return (this.state.loaded)
      ? <BoardComponent />
      : <LoadingComponent onLoad={this.onLoad} />
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx